import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router-dom'
import { LogoVertical } from '@/assets/icons/LogoVertical'
import { Logo } from '@/components/Logo'
import { handleError } from '@/utils/handleError'

interface Props {
  description?: string
  title?: string
}

export const ErrorPage = (props: Props) => {
  const { t } = useTranslation()

  const error = useRouteError()

  useEffect(() => {
    handleError(error, {
      tags: {
        page: 'ErrorPage',
      },
    })
  }, [error])

  return (
    <div className="flex min-h-dvh flex-col">
      <div className="text-primary-inverted bg-yellow-300 py-4">
        <div className="container flex max-w-screen-xl items-center justify-between">
          <Logo />
        </div>
      </div>

      <div className="container flex flex-1 flex-col items-center justify-center">
        <LogoVertical className="text-white" />

        <h1 className="mt-12 text-2xl font-bold">
          {props.title ?? t('errorPage.title')}
        </h1>

        <p className="mt-2 whitespace-pre-line text-center text-secondary">
          {props.description ?? t('errorPage.description')}
        </p>
      </div>

      <footer className="flex items-center justify-center bg-gray-900 px-4 py-8">
        <Logo className="text-white" />
      </footer>
    </div>
  )
}
